import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { BrandMark } from "@/components/marketing/Navbar";

const inputCls = "w-full bg-navy-900/60 border border-white/10 focus:border-gold outline-none px-4 py-3.5 text-white placeholder:text-mist/50 transition-colors duration-300 text-sm";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/portal");
    } catch (err) {
      setError(err.response
        ? formatApiErrorDetail(err.response?.data?.detail)
        : "Having trouble reaching the server — please wait a few seconds and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-navy-950 flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="login-brand-link" className="flex justify-center mb-10"><BrandMark /></Link>
        <form onSubmit={submit} className="bg-navy-900/60 border border-gold/20 p-8 sm:p-10">
          <h1 className="font-serif text-3xl text-white mb-2">Client Portal</h1>
          <p className="text-mist text-sm mb-8">Sign in to track your filings worldwide.</p>
          {error && <p data-testid="login-error" className="text-sm text-red-400 border border-red-400/30 bg-red-400/10 px-4 py-3 mb-6">{error}</p>}
          <div className="flex flex-col gap-5">
            <input type="email" required data-testid="login-email-input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
            <input type="password" required data-testid="login-password-input" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
            <button type="submit" disabled={loading} data-testid="login-submit-button"
              className="mt-2 px-8 py-4 bg-gold text-navy-950 font-semibold text-sm tracking-wide hover:bg-gold-light transition-colors duration-300 disabled:opacity-50">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </div>
          <p className="text-sm text-mist mt-8 text-center">
            New client? <Link to="/portal/register" data-testid="login-register-link" className="text-gold hover:text-gold-light">Create an account</Link>
          </p>
        </form>
        <p className="text-center mt-6">
          <Link to="/" data-testid="login-back-link" className="text-xs text-mist/70 hover:text-gold transition-colors">← Back to claimspace</Link>
        </p>
      </div>
    </div>
  );
}
